'use es6';

import I18n from 'I18n';
import { MIN_MENU_WIDTH } from 'foundations-components/transitional/components/Select/Select.constants';
import { lazyEval } from 'foundations-components/transitional/utils/lazyEval';
import { getCurrentOption } from './DrilldownSelect.helpers';
export const getOptions = component => {
  const {
    options
  } = component.props;
  const {
    optionsStack,
    inputValue,
    filteredOptions,
    value
  } = component.state;
  let currentOptions = options;
  if (inputValue && filteredOptions) {
    currentOptions = filteredOptions;
  } else if (optionsStack.length) {
    currentOptions = optionsStack[optionsStack.length - 1];
  }
  let currentOption;
  if (currentOptions && !currentOptions.some(entry => entry.value === value)) {
    const currentSelection = getCurrentOption(value, options);
    if (currentSelection) {
      currentOption = {
        disabled: true,
        hide: true,
        text: currentSelection.text,
        value: currentSelection.value
      };
    }
  }
  return currentOption ? [...currentOptions, currentOption] : currentOptions;
};
export const getMenuWidth = component => {
  const {
    menuWidth
  } = component.props;
  if (menuWidth === 'auto') {
    return '';
  }
  if (typeof menuWidth === 'number') {
    return menuWidth;
  }
  return Math.max(component.state.controlWidth, MIN_MENU_WIDTH);
};
export const computeControlWidth = (controlEl, open) => {
  if (!controlEl || !open) {
    return 0;
  }
  const exactWidth = controlEl.getBoundingClientRect().width;
  const roundedWidth = window.chrome ? Math.floor(exactWidth) : exactWidth;
  return roundedWidth - 2; // account for 1px border added by UIPopover
};
export const getNoResultsText = (component, {
  noResultsText
}) => {
  if (noResultsText != null) return lazyEval(noResultsText);
  const {
    inputValue
  } = component.state;
  return inputValue ? I18n.text('data-token-picker.drilldownSelect.noResults') : I18n.text('data-token-picker.drilldownSelect.typeToSearch');
};